/* ============================================================
   SKATE Member – Storefront-Client
   Spricht die eigene Rewards-App ausschließlich über den
   Shopify App Proxy an (/apps/suite/member/... – SKATE Club Suite). Same-origin, kein
   Token, kein CORS. Rendert drei Flächen, sofern vorhanden:
     #scMemberPanel  – Side-Tab (global)
     #scMemberPage   – Member-Seite (Template page.member)
     #scMemberPane   – "Treuepunkte" im Dashboard (Mein Bereich)
   Zusätzlich werden alle [data-member-points] mit dem Stand gefüllt.
   ============================================================ */
(function () {
  var CFG = window.SC_MEMBER_CFG || {};
  var PROXY = (CFG.proxy || '/apps/suite/member').replace(/\/+$/, '');
  var PAGE_URL = CFG.pageUrl || '';
  var LOGIN_URL = CFG.loginUrl || '/account/login';
  /* Mehrsprachigkeit: Labels kommen aus den Theme-Sprachdateien (sc-loyalty-tab injiziert CFG.i18n).
     T(key, fallback) mit deutschem Fallback, falls die Injektion fehlt (alte Einbindung). */
  var I18N = CFG.i18n || {};
  function T(k, fb) { var v = (I18N[k] !== undefined && I18N[k] !== '') ? I18N[k] : fb; return v; }
  /* HTML-faehige Labels: entkommt Shopify-seitig doch mal escaped (&lt;b&gt;), zurueckwandeln */
  function TH(k, fb) { return String(T(k, fb)).replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&'); }
  function fmt(tpl) { var a = arguments; var i = 0; return String(tpl).replace(/\{[a-z]+\}/g, function (m) { i++; return a[i] !== undefined ? a[i] : m; }); }
  var TABLABEL = CFG.tabLabel || T('tabLabel', 'Treuepunkte');
  var HEADLINE = CFG.headline || T('headline', 'Sammle mit jeder Buchung Punkte und löse sie bei deinem nächsten Camp ein.');
  var LOADING = '<div class="sc-mem-skel">' + T('loading', 'Lädt …') + '</div>';

  /* Anzeige-Labels für die technischen reason-Keys (CI-Wording-Hoheit im Theme) */
  var REASONS = Object.assign({
    purchase: 'Einkauf', join: 'Willkommensbonus', visit: 'Shop-Besuch', birthday: 'Geburtstagsbonus',
    feedback: 'Camp-Bewertung', social: 'Social Media', google: 'Google-Bewertung', redeem: 'Prämie eingelöst',
    refund: 'Rückerstattung', expire: 'Punkte verfallen', adjust: 'Anpassung', credit: 'Gutschrift',
    debit: 'Punkte abgezogen', migration: 'Guthaben-Übertrag'
  }, I18N.reasons || {});
  var RULES_I18N = I18N.rules || {};

  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l2.7 5.8 6.3.8-4.6 4.3 1.2 6.2L12 17l-5.6 3.1 1.2-6.2L3 9.6l6.3-.8z"/></svg>';
  var CAKE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20h16M5 20v-6a2 2 0 012-2h10a2 2 0 012 2v6"/><path d="M12 12V8M9 8h6"/><path d="M12 3.5c.9.7 1 1.8 0 2.5-1-.7-.9-1.8 0-2.5z"/></svg>';
  // Gefülltes Geschenk-Icon – passt zum Fill-Stil der anderen Sammel-Icons (Stern etc.)
  var GIFT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 8H4.5A1.5 1.5 0 013 6.5C3 4.9 4.3 4 5.8 4.2 7 4.4 8 5.2 9 6.4c.6.7 1.1 1.4 1.5 2.1L11 8zm2 0c.4-.7.9-1.4 1.5-2.1 1-1.2 2-2 3.2-2.2C19.7 3.5 21 4.9 21 6.5A1.5 1.5 0 0119.5 8H13zM6.6 6.2c-.4.3-.3 1 .5 1H9c-.4-.6-1-1.2-1.5-1.5-.3-.2-.6-.2-.9.5zm10.8 0c-.3-.7-.6-.7-.9-.5-.5.3-1.1.9-1.5 1.5h1.9c.8 0 .9-.7.5-1z"/><path d="M3.5 9.5h7v4h-7zM13.5 9.5h7v4h-7zM4.5 15h6v6H6a1.5 1.5 0 01-1.5-1.5V15zM13.5 15h6v4.5A1.5 1.5 0 0118 21h-4.5v-6z"/></svg>';

  var state = null;
  var loading = false;
  var flash = null;      // { type:'err'|'ok', msg }
  var lastCode = null;   // soeben erstellter Gutschein – für sofortiges Feedback, bis /me ihn enthält
  var LS_KEY = 'sc_member_codes';   // lokal gemerkte Gutscheine (Fallback, falls die App keine liefert)

  function getLocalCodes() { try { return JSON.parse(localStorage.getItem(LS_KEY) || '[]'); } catch (e) { return []; } }
  function setLocalCodes(a) { try { localStorage.setItem(LS_KEY, JSON.stringify(a)); } catch (e) {} }
  function addLocalCode(code, value) {
    if (!code) return;
    var a = getLocalCodes();
    if (!a.some(function (x) { return x.code === code; })) a.unshift({ code: code, value: value });
    setLocalCodes(a.slice(0, 20));
  }
  function removeLocalCode(code) { setLocalCodes(getLocalCodes().filter(function (x) { return x.code !== code; })); }

  /* ---------- Helpers ---------- */
  function el(id) { return document.getElementById(id); }
  function nf(n) { try { return new Intl.NumberFormat('de-DE').format(n); } catch (e) { return '' + n; } }
  function pts(n) { return (n === null || n === undefined) ? '–' : nf(n); }
  function euro(v) {
    if (v === null || v === undefined) return '';
    return '€' + (Number(v) % 1 === 0 ? v : Number(v).toFixed(2).replace('.', ','));
  }
  function esc(s) {
    return (s === null || s === undefined ? '' : String(s)).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear();
  }
  var MONTHS_DE = (T('months', '') ? T('months', '').split(',') : ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']);
  function dayOpts() {
    var o = '<option value="">' + T('day', 'Tag') + '</option>';
    for (var i = 1; i <= 31; i++) { o += '<option value="' + ('0' + i).slice(-2) + '">' + i + '</option>'; }
    return o;
  }
  function monthOpts() {
    var o = '<option value="">' + T('month', 'Monat') + '</option>';
    for (var i = 0; i < 12; i++) { o += '<option value="' + ('0' + (i + 1)).slice(-2) + '">' + MONTHS_DE[i] + '</option>'; }
    return o;
  }
  function yearOpts() {
    var o = '<option value="">' + T('year', 'Jahr') + '</option>';
    var now = new Date().getFullYear();
    for (var y = now - 5; y >= 1930; y--) { o += '<option value="' + y + '">' + y + '</option>'; }
    return o;
  }

  function api(path, opts) {
    var url = PROXY + path + (path.indexOf('?') > -1 ? '&' : '?') + 'ts=' + Date.now();
    var o = opts || {};
    o.headers = Object.assign({ 'Accept': 'application/json' }, o.headers || {});
    o.credentials = 'same-origin';
    return fetch(url, o).then(function (r) { return r.json(); });
  }

  function load() {
    if (loading) return Promise.resolve();
    loading = true;
    return api('/me').then(function (s) { state = s || { member: false }; })
      .catch(function () { state = { member: false, _error: true }; })
      .then(function () { loading = false; renderAll(); });
  }

  /* Prämien-Name lokalisiert: Standard-Gutscheine („10 € Gutschein") werden aus dem strukturierten
     value-Feld in der aktiven Sprache gebaut. Individuell benannte Prämien (kein Gutschein-Muster)
     bleiben unverändert – die App liefert dafür weiterhin den Betreiber-Text. */
  var VOUCHER_DE = /^\s*\d+([.,]\d+)?\s*€?\s*[-‑–]?\s*Gutschein\s*$/i;
  function rewardName(r) {
    if (r && r.value != null && (!r.label || VOUCHER_DE.test(r.label))) return fmt(T('reward_voucher', '{v} € Gutschein'), r.value);
    return (r && r.label) || '';
  }

  /* ---------- Fortschrittsbalken ---------- */
  function progressHTML(s) {
    var p = s.points || 0;
    var nr = s.next_reward;
    if (!nr) {
      return '<div class="sc-mem-prog"><div class="track"><span style="width:100%"></span></div>' +
        '<div class="lbl">' + T('progress_max', 'Höchste Prämie freigeschaltet – stark!') + '</div></div>';
    }
    var pct = Math.max(3, Math.min(100, Math.round(p / nr.cost * 100)));
    var rem = Math.max(0, nr.cost - p);
    return '<div class="sc-mem-prog"><div class="track"><span style="width:' + pct + '%"></span></div>' +
      '<div class="lbl">' + fmt(TH('progress', 'Noch <b>{n}</b> Punkte bis <b>{r}</b>'), '<b>' + pts(rem) + '</b>', '<b>' + esc(rewardName(nr)) + '</b>').replace('<b><b>','<b>').replace('</b></b>','</b>') + '</div></div>';
  }

  /* Gesperrte („pending") Punkte – z. B. 14-Tage-Sperre nach dem Kauf, bis Storno-/Retourenfrist durch ist */
  function pendingHTML(s) {
    if (!s || !s.pending_points || s.pending_points <= 0) return '';
    var until = s.pending_until ? fmtDate(s.pending_until) : '';
    var days = s.lock_days || 14;
    return '<div class="sc-mem-pending"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4.5" y="10.5" width="15" height="9" rx="2"/><path d="M8 10.5V8a4 4 0 018 0v2.5"/></svg>' +
      '<span>' + fmt(T('pending', '+{n} Punkte – nach {d} Tagen nutzbar'), nf(s.pending_points), days) + (until ? fmt(T('pending_from', ', ab {date}'), until) : '') + '</span></div>';
  }

  function flashHTML() {
    if (!flash) return '';
    return '<div class="sc-mem-flash ' + flash.type + '">' + esc(flash.msg) +
      '<button type="button" data-flash-dismiss aria-label="' + esc(T('close', 'Schließen')) + '">✕</button></div>';
  }

  function vouchersHTML(s) {
    // Quelle der Wahrheit ist die App: liefert /me ein codes-Array (auch leer), gilt genau das
    // (geräteübergreifend, verbrauchte Codes verschwinden automatisch). Fehlt das Feld ganz,
    // greift der lokale Fallback (nur dieser Browser).
    var hasApp = Array.isArray(s.codes);
    var list = hasApp ? s.codes.slice() : getLocalCodes();
    // Soeben erstellten Gutschein sofort zeigen, falls /me ihn noch nicht enthält.
    if (lastCode && lastCode.code && !list.some(function (c) { return c.code === lastCode.code; })) {
      list.unshift({ code: lastCode.code, value: lastCode.value });
    }
    if (!list.length) return '';
    var rows = list.map(function (v) {
      var c = v.code;
      return '<div class="sc-vch">' +
        '<div class="sc-vch-l">' +
          '<div class="v">' + (v.value != null ? fmt(T('voucher_of', '{v}-Gutschein'), euro(v.value)) : T('voucher', 'Gutschein')) + '</div>' +
          '<code>' + esc(c) + '</code>' +
        '</div>' +
        '<div class="sc-vch-r">' +
          '<button type="button" class="cp" data-copy="' + esc(c) + '">' + esc(T('copy', 'Kopieren')) + '</button>' +
          '<a class="sc-btn sc-btn-teal" href="/discount/' + encodeURIComponent(c) + '?redirect=/cart">' + esc(T('redeem', 'Einlösen')) + '</a>' +
          (hasApp ? '' : '<button type="button" class="rm" data-code-remove="' + esc(c) + '" aria-label="✕">✕</button>') +
        '</div>' +
      '</div>';
    }).join('');
    return '<div class="sc-mem-vouchers">' +
      '<div class="hd">' + STAR + ' ' + esc(T('vouchers_h', 'Deine Gutscheine')) + '</div>' +
      rows +
      (hasApp ? '' : '<p class="sc-vch-note">' + esc(T('vouchers_note', 'Diese Codes sind auf diesem Gerät gespeichert. Du findest sie außerdem in deiner Bestätigungs-E-Mail.')) + '</p>') +
      '</div>';
  }

  /* ---------- Side-Tab ---------- */
  function renderTab() {
    var panel = el('scMemberPanel');
    if (!panel) return;
    if (!state) { panel.innerHTML = LOADING; return; }

    if (state.member) {
      panel.innerHTML =
        '<h3>' + STAR + ' ' + esc(TABLABEL) + '</h3>' +
        '<div class="sc-mem-hello">' + fmt(esc(T('hello', 'Hallo, {name}!')), esc(state.name || T('member', 'Member'))) + '</div>' +
        '<div class="sc-mem-ptsbig">' + pts(state.points) + ' <span>' + esc(T('points', 'Punkte')) + '</span></div>' +
        pendingHTML(state) +
        progressHTML(state) +
        '<a href="' + esc(PAGE_URL || '/pages/mein-bereich#points') + '" class="sc-btn sc-btn-teal">' + esc(T('overview_btn', 'Treuepunkte-Übersicht')) + '</a>';
    } else {
      panel.innerHTML =
        '<h3>' + STAR + ' ' + esc(TABLABEL) + '</h3>' +
        '<p>' + esc(state.headline || HEADLINE) + '</p>' +
        '<div class="sc-mem-guestrows">' +
        '<div class="sc-loy-row"><span>' + esc(T('guest_r1a', 'Bei jeder Buchung')) + '</span><b>' + esc(T('guest_r1b', 'Punkte sammeln')) + '</b></div>' +
        '<div class="sc-loy-row"><span>' + esc(T('guest_r2a', 'Punkte einlösen')) + '</span><b>' + esc(T('guest_r2b', 'Gutscheine sichern')) + '</b></div>' +
        '</div>' +
        '<a href="' + esc(LOGIN_URL) + '" class="sc-btn sc-btn-teal">' + esc(T('login_collect', 'Anmelden & Punkte sammeln')) + '</a>';
    }
  }

  /* ---------- Member-Seite ---------- */
  function loggedOutHTML() {
    return '<div class="sc-mem-out">' +
      '<div class="ico">' + STAR + '</div>' +
      '<h3>' + esc(T('welcome', 'Willkommen im SKATE Member-Programm')) + '</h3>' +
      '<p>' + esc((state && state.headline) || HEADLINE) + '</p>' +
      '<a href="' + esc(LOGIN_URL) + '" class="sc-btn sc-btn-petrol">' + esc(T('login_collect', 'Anmelden & Punkte sammeln')) + '</a>' +
      '</div>';
  }

  function rewardsHTML(s) {
    if (!s.rewards || !s.rewards.length) return '';
    var h = '<h3 class="sc-mem-h">' + esc(T('rewards_h', 'Prämien einlösen')) + '</h3><div class="sc-mem-rewards">';
    s.rewards.forEach(function (r) {
      var afford = (s.points || 0) >= r.cost;
      h += '<div class="sc-mem-reward' + (afford ? '' : ' locked') + '">' +
        '<div class="v">' + euro(r.value) + '</div>' +
        '<div class="l">' + esc(rewardName(r)) + '</div>' +
        '<div class="c">' + fmt(T('points_cost', '{n} Punkte'), pts(r.cost)) + '</div>' +
        (afford
          ? '<button type="button" class="sc-btn sc-btn-petrol" data-redeem="' + esc(r.id) + '">' + esc(T('redeem', 'Einlösen')) + '</button>'
          : '<button type="button" class="sc-btn sc-btn-outline" disabled>' + fmt(T('still', 'Noch {n}'), pts(r.cost - (s.points || 0))) + '</button>') +
        '</div>';
    });
    return h + '</div>';
  }

  function rulesHTML(s) {
    if (!s.earn_rules || !s.earn_rules.length) return '';
    var h = '<h3 class="sc-mem-h">' + esc(T('rules_h', 'Punkte sammeln')) + '</h3><div class="sc-mem-rules">';
    /* Lokalisierte Regel-Texte aus strukturierten API-Feldern (Member-App >= 0.4.24); sonst API-Text. */
    function ruleLabel(rule) {
      var L = RULES_I18N;
      if (rule.key === 'purchase' && rule.points_per_euro != null) return { l: L.purchase || rule.label, d: fmt(L.purchase_d || '{p} Punkt pro €1', rule.points_per_euro) + (rule.lock_days ? fmt(L.lock || ' · nach {d} Tagen nutzbar', rule.lock_days) : '') };
      if (rule.key === 'visit' && rule.points != null) return { l: L.visit || rule.label, d: fmt(L.visit_d || '{p} Punkte · automatisch, 1× pro Woche', rule.points) };
      if (rule.key === 'birthday' && rule.points != null) return { l: L.birthday || rule.label, d: fmt(L.birthday_d || '{p} Punkte · automatisch am Geburtstag', rule.points) };
      if (rule.key === 'feedback' && rule.points != null) return { l: L.feedback || rule.label, d: fmt(L.feedback_d || '{p} Punkte · automatisch nach der Camp-Bewertung', rule.points) };
      if (rule.key === 'social' && rule.points != null) return { l: L.social || rule.label, d: fmt(L.points || '{p} Punkte', rule.points) };
      if (rule.key === 'google' && rule.points != null) return { l: L.google || rule.label, d: fmt(L.points || '{p} Punkte', rule.points) };
      return { l: rule.label, d: rule.detail };
    }
    s.earn_rules.forEach(function (rule) {
      if (rule.key === 'birthday') {
        if (rule.needsBirthday) {
          h += '<div class="sc-mem-rule bday">' +
            '<div class="ico">' + GIFT + '</div>' +
            '<div class="txt">' +
              '<b>' + esc(rule.label) + '</b>' +
              '<span>' + esc(rule.detail) + ' – trag dein Geburtsdatum ein und sichere dir jedes Jahr deinen Bonus.</span>' +
              '<div class="sc-mem-bday">' +
                '<div class="sc-mem-dob">' +
                  '<select data-dob-d aria-label="' + esc(T('day', 'Tag')) + '">' + dayOpts() + '</select>' +
                  '<select data-dob-m aria-label="' + esc(T('month', 'Monat')) + '">' + monthOpts() + '</select>' +
                  '<select data-dob-y aria-label="' + esc(T('year', 'Jahr')) + '">' + yearOpts() + '</select>' +
                '</div>' +
                '<button type="button" class="sc-mem-claim" data-bday-save>' + esc(T('bday_save', 'Bonus sichern')) + '</button>' +
              '</div>' +
              '<p class="sc-mem-bday-hint"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 11v5M12 8v.01"/></svg>' +
                '<span>' + TH('bday_hint', 'Du kannst dein Geburtsdatum <b>nur einmalig selbst</b> setzen – danach nur noch über unser Team. Bitte prüfe deine Eingabe vor dem Speichern.') + '</span></p>' +
            '</div>' +
          '</div>';
        } else {
          h += '<div class="sc-mem-rule">' +
            '<div class="ico">' + GIFT + '</div>' +
            '<div class="txt"><b>' + esc(ruleLabel(rule).l) + '</b><span>' + esc(ruleLabel(rule).d) + '</span></div>' +
            (s.birthday ? '<div class="act"><span class="sc-mem-bdaychip">' + fmtDate(s.birthday) + '</span></div>' : '') +
          '</div>';
        }
        return;
      }
      // Alle übrigen Punkte werden automatisch gutgeschrieben – kein „Abholen"-Button.
      h += '<div class="sc-mem-rule">' +
        '<div class="ico">' + STAR + '</div>' +
        '<div class="txt"><b>' + esc(ruleLabel(rule).l) + '</b><span>' + esc(ruleLabel(rule).d) + '</span></div>' +
        '</div>';
    });
    return h + '</div>';
  }

  function historyHTML(s) {
    if (!s.history || !s.history.length) return '';
    var h = '<h3 class="sc-mem-h">' + esc(T('history_h', 'Verlauf')) + '</h3><div class="sc-mem-hist">';
    s.history.forEach(function (row) {
      var up = row.delta >= 0;
      // Bei manuellen Buchungen (Gutschrift/Abzug) den vom Betreiber gewählten Grund mit anzeigen.
      var label = esc(REASONS[row.reason] || row.reason);
      if (row.note) label += ' · ' + esc(row.note);
      h += '<div class="row">' +
        '<span class="r">' + label + '</span>' +
        '<span class="d">' + fmtDate(row.created_at) + '</span>' +
        '<span class="delta ' + (up ? 'up' : 'down') + '">' + (up ? '+' : '') + nf(row.delta) + '</span>' +
        '</div>';
    });
    return h + '</div>';
  }

  function renderPage() {
    var root = el('scMemberPage');
    if (!root) return;
    if (!state) { root.innerHTML = LOADING; return; }
    if (!state.member) { root.innerHTML = loggedOutHTML(); return; }

    var s = state;
    root.innerHTML =
      flashHTML() +
      '<div class="sc-mem-hero">' +
        '<div class="sc-mem-hero-l">' +
          '<div class="sc-mem-hello">' + fmt(esc(T('hello', 'Hallo, {name}!')), esc(s.name || T('member', 'Member'))) + '</div>' +
          '<div class="sc-mem-ptsbig">' + pts(s.points) + ' <span>' + esc(T('points', 'Punkte')) + '</span></div>' +
          pendingHTML(s) +
        '</div>' +
        '<div class="sc-mem-hero-r">' + progressHTML(s) + '</div>' +
      '</div>' +
      vouchersHTML(s) +
      rewardsHTML(s) + rulesHTML(s) + historyHTML(s);
    bind(root);
  }

  /* ---------- Dashboard-Pane ---------- */
  function renderPane() {
    var root = el('scMemberPane');
    if (!root) return;
    if (!state) { root.innerHTML = LOADING; return; }
    if (!state.member) {
      root.innerHTML = '<p style="color:var(--sc-muted)">' + esc(T('pane_login', 'Melde dich an, um deine Treuepunkte zu sehen.')) + '</p>' +
        '<a href="' + esc(LOGIN_URL) + '" class="sc-btn sc-btn-petrol" style="margin-top:12px">' + esc(T('login', 'Anmelden')) + '</a>';
      return;
    }
    var s = state;
    root.innerHTML =
      flashHTML() +
      '<div class="sc-mem-hero compact">' +
        '<div><div class="sc-mem-ptsbig">' + pts(s.points) + ' <span>' + esc(T('points', 'Punkte')) + '</span></div>' + pendingHTML(s) + '</div>' +
        '<div class="sc-mem-hero-r">' + progressHTML(s) + '</div>' +
      '</div>' +
      vouchersHTML(s) +
      rewardsHTML(s) +
      (PAGE_URL ? '<a href="' + esc(PAGE_URL) + '" class="sc-btn sc-btn-outline" style="margin-top:20px">' + esc(T('all_rewards', 'Alle Prämien & Verlauf')) + '</a>' : '');
    bind(root);
  }

  /* ---------- Punktestand in Statistik-Kacheln ---------- */
  function renderPointsSpans() {
    var p = (state && state.member) ? pts(state.points) : '–';
    document.querySelectorAll('[data-member-points]').forEach(function (n) { n.textContent = p; });
  }

  function renderAll() { renderTab(); renderPage(); renderPane(); renderPointsSpans(); }

  /* ---------- Schönes CI-Bestätigungs-Popup (statt window.confirm) ---------- */
  function scConfirm(opts) {
    return new Promise(function (resolve) {
      var ov = document.createElement('div');
      ov.className = 'sc-modal';
      ov.innerHTML =
        '<div class="sc-modal-box" role="dialog" aria-modal="true" aria-label="' + esc(opts.title || T('confirm', 'Bestätigen')) + '">' +
          '<div class="sc-modal-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="5" width="16" height="16" rx="2.5"/><path d="M8 3v4M16 3v4M4 10h16"/><path d="M9.3 15.4l1.8 1.8 3.6-3.8"/></svg></div>' +
          '<h3 class="sc-modal-title">' + esc(opts.title || T('confirm', 'Bestätigen')) + '</h3>' +
          '<div class="sc-modal-text">' + (opts.message || '') + '</div>' +
          '<div class="sc-modal-acts">' +
            '<button type="button" class="sc-btn sc-btn-outline" data-x>' + esc(opts.cancel || T('cancel', 'Abbrechen')) + '</button>' +
            '<button type="button" class="sc-btn sc-btn-teal" data-ok>' + esc(opts.ok || T('confirm', 'Bestätigen')) + '</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(ov);
      document.documentElement.classList.add('sc-modal-lock');
      requestAnimationFrame(function () { ov.classList.add('open'); });
      function done(v) {
        ov.classList.remove('open');
        document.documentElement.classList.remove('sc-modal-lock');
        document.removeEventListener('keydown', onKey);
        setTimeout(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 220);
        resolve(v);
      }
      function onKey(e) { if (e.key === 'Escape') done(false); }
      ov.querySelector('[data-ok]').addEventListener('click', function () { done(true); });
      ov.querySelector('[data-x]').addEventListener('click', function () { done(false); });
      ov.addEventListener('click', function (e) { if (e.target === ov) done(false); });
      document.addEventListener('keydown', onKey);
      setTimeout(function () { var b = ov.querySelector('[data-ok]'); if (b) b.focus(); }, 60);
    });
  }

  /* ---------- Aktionen binden ---------- */
  function bind(root) {
    root.querySelectorAll('[data-redeem]').forEach(function (b) {
      b.addEventListener('click', function () { doRedeem(b.getAttribute('data-redeem'), b); });
    });
    var save = root.querySelector('[data-bday-save]');
    if (save) {
      save.addEventListener('click', function () {
        var d = root.querySelector('[data-dob-d]'), m = root.querySelector('[data-dob-m]'), y = root.querySelector('[data-dob-y]');
        var date = (d && m && y && d.value && m.value && y.value) ? (y.value + '-' + m.value + '-' + d.value) : '';
        if (date) {
          var human = d.value + '.' + m.value + '.' + y.value;
          scConfirm({
            title: T('bday_confirm_t', 'Geburtsdatum speichern?'),
            message: fmt(TH('bday_confirm_m', 'Du hast <b>{date}</b> gewählt.<br>Du kannst dein Geburtsdatum danach <b>nur noch über unser Team</b> ändern lassen – bitte prüfe deine Eingabe.'), '<b>' + esc(human) + '</b>').replace('<b><b>','<b>').replace('</b></b>','</b>'),
            ok: T('save', 'Speichern'), cancel: T('cancel', 'Abbrechen')
          }).then(function (okv) { if (okv) doBirthday(date, save); });
          return;
        }
        doBirthday(date, save);
      });
    }
    root.querySelectorAll('[data-copy]').forEach(function (b) {
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-copy');
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () {
          b.textContent = T('copied', 'Kopiert ✓');
          setTimeout(function () { b.textContent = T('copy', 'Kopieren'); }, 1800);
        });
      });
    });
    root.querySelectorAll('[data-code-remove]').forEach(function (b) {
      b.addEventListener('click', function () { removeLocalCode(b.getAttribute('data-code-remove')); renderAll(); });
    });
    var fx = root.querySelector('[data-flash-dismiss]');
    if (fx) fx.addEventListener('click', function () { flash = null; renderAll(); });
  }

  function setFlash(type, msg) { flash = { type: type, msg: msg }; }

  function doRedeem(id, btn) {
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    api('/redeem', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ reward_id: id })
    }).then(function (res) {
      if (res && res.ok) {
        lastCode = { code: res.code, value: res.value };
        addLocalCode(res.code, res.value);
        setFlash('ok', T('flash_voucher_ok', 'Gutschein erstellt – du findest ihn oben unter „Deine Gutscheine".'));
        return load();
      }
      setFlash('err', (res && res.error) || T('flash_redeem_err', 'Einlösen aktuell nicht möglich.'));
      renderAll();
    }).catch(function () { setFlash('err', T('flash_conn_err', 'Verbindung fehlgeschlagen. Bitte später erneut versuchen.')); renderAll(); });
  }

  function doBirthday(date, btn) {
    if (!date) { setFlash('err', T('flash_bday_need', 'Bitte gib zuerst dein Geburtsdatum ein.')); renderAll(); return; }
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    api('/birthday', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ date: date })
    }).then(function (res) {
      if (res && res.ok) { setFlash('ok', T('flash_bday_ok', 'Geburtstag gespeichert – dein Bonus wartet auf dich!')); return load(); }
      // Datum bereits gesetzt: Meldung zeigen und Eingabefeld ausblenden (frisches /me liefert needsBirthday:false).
      if (res && res.locked) { setFlash('err', res.error || T('flash_bday_locked', 'Dein Geburtsdatum ist bereits hinterlegt und kann nur noch über unser Team geändert werden.')); return load(); }
      setFlash('err', (res && res.error) || T('flash_bday_err', 'Geburtstag konnte nicht gespeichert werden.'));
      renderAll();
    }).catch(function () { setFlash('err', T('flash_conn_err', 'Verbindung fehlgeschlagen. Bitte später erneut versuchen.')); renderAll(); });
  }

  /* Öffentliche API fürs Theme (optional) */
  window.SCMember = { refresh: load, redeem: doRedeem, setBirthday: doBirthday, state: function () { return state; } };

  /* ---------- Boot ---------- */
  function boot() {
    if (el('scMemberTab') || el('scMemberPage') || el('scMemberPane') || document.querySelector('[data-member-points]')) {
      load();
    }
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
